import React from 'react'
import { createPortal } from 'react-dom'

import InputField from 'src/components/InputField'
import Resend     from './Resend'
import Panel      from './Panel'
import SignIn     from './SignIn'
import SignUp     from './SignUp'
import Button     from './Button'

import { csrfToken } from 'src/utils/csrfHeaders'

const Form = props =>
  <div>
    {
      props.errors?.base?.[0] &&
      <div className="alert alert-danger">
        <div dangerouslySetInnerHTML={{ __html: props.errors.base[0] }} />
        {props.resend ? <Resend {...props} /> : null}
      </div>
    }

    <form method="post" action={props.action} onSubmit={props.handleSubmit} noValidate>
      <div>
        <input type="hidden" name="authenticity_token" value={csrfToken()} />
        <input type="hidden" name="source" defaultValue={props.source} />
        <input type="hidden" name="cobrand" defaultValue={props.cobrand} />
      </div>

      <InputField
        {...props.inputProps('email')}
        type="email"
        label="Work or personal email"
        requiredLabel={false}
        placeholder="you@example.com"
        onChange={props.handleEmailChange}
        autoFocus
        autoComplete="username webauthn"
        required
        readOnly={props.emailReadonly}
      />

      <Panel
        show={props.action == props.urls.signin}
        hideContentsWhenCollapsed={props.action == props.urls.signup}
      >
        <SignIn {...props} />
      </Panel>

      <Panel show={props.action == props.urls.signup}>
        <SignUp {...props} />
      </Panel>

      <Button {...props} />
      {props.children}

      {createPortal(
        <Panel show={props.action == props.urls.signin}>
          <p>
            <a
              href={[
                props.urls.passwordReset,
                new URLSearchParams({ 'user[email]': props.user.email }),
              ].join(props.urls.passwordReset.includes('?') ? '&' : '?')}
              className="font-weight-bold"
            >
              Forgot your password?
            </a>
          </p>
        </Panel>
      , document.getElementById('ForgotPasswordRoot'))}
    </form>
  </div>

export default Form
